<template>
  <div class="solutions-page">
    <Headers />

    <!-- 页面标题 -->
    <section class="page-hero">
      <div class="hero-container">
        <h1>解决方案</h1>
        <p>针对不同行业场景，提供专业的AI算力解决方案</p>
      </div>
    </section>

    <!-- 教育行业解决方案 -->
    <section class="solution-section" id="education">
      <div class="solution-container">
        <div class="solution-header">
          <div class="solution-icon">
            <i class="el-icon-reading xc-icon"></i>
          </div>
          <div>
            <h2>教育行业 AI 实验平台</h2>
            <p class="solution-tagline">30分钟搭建全校AI实验平台</p>
          </div>
        </div>

        <div class="solution-content">
          <div class="content-grid">
            <div class="content-left">
              <h3>🎓 教育行业效率革命</h3>
              <p class="description">
                某高校AI课程实验室成功案例：50名学生并发使用，零排队等待，实验成本降低68%，模型训练速度超校内机房3倍。
              </p>

              <div class="case-highlights">
                <div class="highlight-card">
                  <div class="highlight-number">50名</div>
                  <div class="highlight-label">学生并发使用</div>
                  <div class="highlight-desc">零排队等待</div>
                </div>
                <div class="highlight-card">
                  <div class="highlight-number">68%</div>
                  <div class="highlight-label">成本降低</div>
                  <div class="highlight-desc">￥3.2万→￥1.02万</div>
                </div>
                <div class="highlight-card">
                  <div class="highlight-number">3倍</div>
                  <div class="highlight-label">训练速度</div>
                  <div class="highlight-desc">超校内机房</div>
                </div>
              </div>

              <div class="features">
                <h4>核心优势</h4>
                <div class="feature-list">
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <span>开箱即用镜像：预装10+AI教学套件（图形化编程/AI绘画）</span>
                  </div>
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <span>零运维成本：云端自动更新环境，无需本地部署</span>
                  </div>
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <span>分组计费模式：40人班级1节课成本＜15元（￥0.38/人）</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="content-right">
              <div class="case-study">
                <h4>郑州XX中学实测案例</h4>
                <div class="case-stats">
                  <div class="stat-item">
                    <span class="stat-label">传统机房改造费用节省</span>
                    <span class="stat-value">82%</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">学生满意度</span>
                    <span class="stat-value">95%</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">课程完成率提升</span>
                    <span class="stat-value">45%</span>
                  </div>
                </div>

                <div class="teaching-tools">
                  <h5>教学工具包</h5>
                  <div class="tool-tags">
                    <span class="tool-tag">Jupyter Notebook</span>
                    <span class="tool-tag">PyTorch教学版</span>
                    <span class="tool-tag">TensorFlow Playground</span>
                    <span class="tool-tag">AI绘画工具</span>
                    <span class="tool-tag">语音识别实验</span>
                    <span class="tool-tag">计算机视觉套件</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 设计工作室解决方案 -->
    <section class="solution-section alt" id="design">
      <div class="solution-container">
        <div class="solution-header">
          <div class="solution-icon">
            <i class="el-icon-picture xc-icon"></i>
          </div>
          <div>
            <h2>🎨 设计工作室效率革命</h2>
            <p class="solution-tagline">AI创意设计，释放无限想象</p>
          </div>
        </div>

        <div class="solution-content">
          <div class="content-grid">
            <div class="content-left">
              <h3>上海XX设计公司成功案例</h3>
              <p class="description">
                专业设计团队通过我们的AI算力平台，在创意设计效率上实现了质的飞跃，不仅大幅缩短了项目周期，还显著降低了制作成本。
              </p>

              <div class="design-benefits">
                <div class="benefit-item">
                  <div class="benefit-icon">
                    <i class="el-icon-lightning xc-icon"></i>
                  </div>
                  <div>
                    <h4>Stable Diffusion批量出图</h4>
                    <p>效率提升150%，创意产出翻倍</p>
                  </div>
                </div>
                <div class="benefit-item">
                  <div class="benefit-icon ">
                    <i class="el-icon-coin xc-icon"></i>
                  </div>
                  <div>
                    <h4>成本大幅降低</h4>
                    <p>单张海报成本＜0.3元（原本地渲染￥1.2）</p>
                  </div>
                </div>
                <div class="benefit-item">
                  <div class="benefit-icon">
                    <i class="el-icon-connection xc-icon"></i>
                  </div>
                  <div>
                    <h4>云端协作</h4>
                    <p>支持ComfyUI云端协作工作流</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="content-right">
              <div class="workflow-showcase">
                <h4>设计工作流程</h4>
                <div class="workflow-steps">
                  <div class="workflow-step">
                    <div class="step-number">1</div>
                    <div class="step-content">
                      <h5>创意构思</h5>
                      <p>设计师输入创意提示词</p>
                    </div>
                  </div>
                  <div class="workflow-step">
                    <div class="step-number">2</div>
                    <div class="step-content">
                      <h5>AI生成</h5>
                      <p>云端GPU快速渲染多版本方案</p>
                    </div>
                  </div>
                  <div class="workflow-step">
                    <div class="step-number">3</div>
                    <div class="step-content">
                      <h5>精细调整</h5>
                      <p>专业工具进行后期优化</p>
                    </div>
                  </div>
                  <div class="workflow-step">
                    <div class="step-number">4</div>
                    <div class="step-content">
                      <h5>交付成果</h5>
                      <p>高质量设计作品快速交付</p>
                    </div>
                  </div>
                </div>

                <div class="design-metrics">
                  <div class="metric-card">
                    <div class="metric-number">12.36秒</div>
                    <div class="metric-label">平均出图速度</div>
                    <div class="metric-compare">行业领先</div>
                  </div>
                  <div class="metric-card">
                    <div class="metric-number">￥0.3</div>
                    <div class="metric-label">单张成本</div>
                    <div class="metric-compare">vs ￥1.2传统方式</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 性能数据对比 -->
    <section class="performance-comparison" id="performance">
      <div class="performance-container">
        <h2>行业性能对比</h2>
        <p class="performance-subtitle">与主流云服务商实测数据对比</p>

        <div class="comparison-grid">
          <div class="comparison-card">
            <h3>出图速度对比</h3>
            <div class="comparison-chart">
              <div class="chart-bar">
                <div class="bar-label">我们的平台</div>
                <div class="bar-container">
                  <div class="bar-fill our-platform" style="width: 71%"></div>
                  <span class="bar-value">12.36秒</span>
                </div>
              </div>
              <div class="chart-bar">
                <div class="bar-label">行业平均</div>
                <div class="bar-container">
                  <div class="bar-fill industry-avg" style="width: 100%"></div>
                  <span class="bar-value">17.38秒</span>
                </div>
              </div>
            </div>
          </div>

          <div class="comparison-card">
            <h3>成本对比</h3>
            <div class="comparison-chart">
              <div class="chart-bar">
                <div class="bar-label">我们的平台</div>
                <div class="bar-container">
                  <div class="bar-fill our-platform" style="width: 45%"></div>
                  <span class="bar-value">￥1.82/小时</span>
                </div>
              </div>
              <div class="chart-bar">
                <div class="bar-label">阿里云</div>
                <div class="bar-container">
                  <div class="bar-fill competitor" style="width: 85%"></div>
                  <span class="bar-value">￥3.42/小时</span>
                </div>
              </div>
              <div class="chart-bar">
                <div class="bar-label">腾讯云</div>
                <div class="bar-container">
                  <div class="bar-fill competitor" style="width: 100%"></div>
                  <span class="bar-value">￥4.05/小时</span>
                </div>
              </div>
            </div>
          </div>

          <div class="comparison-card">
            <h3>技术优势</h3>
            <div class="tech-advantages">
              <div class="advantage-item">
                <i class="el-icon-lightning xc-icon"></i>
                <div>
                  <h4>零配置加速</h4>
                  <p>实测提速40%</p>
                </div>
              </div>
              <div class="advantage-item">
                <i class="el-icon-connection xc-icon"></i>
                <div>
                  <h4>梯度压缩技术</h4>
                  <p>比AIACC效率高22%</p>
                </div>
              </div>
              <div class="advantage-item">
                <i class="el-icon-box xc-icon"></i>
                <div>
                  <h4>沙箱隔离</h4>
                  <p>99.9%可用性保障</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



    <!-- 独家技术 -->
    <section class="technology-section" id="technology">
      <div class="technology-container">
        <h2 class="section-title"><i class="xc-icon">🛠️</i> 多样的大模型场景</h2>
        <!-- 轮播图 -->
        <el-carousel :interval="4000" type="card" height="400px" :autoplay="true" :loop="true">
          <el-carousel-item v-for="(item, index) in techItems" :key="index">
            <div class="carousel-card" :style="{ backgroundImage: 'url(' + item.image + ')' }">
              <div class="carousel-content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
    </section>




    <!-- CTA区域 -->
    <section class="cta-section">
      <div class="cta-container">
        <h2>准备为您的行业提供专业解决方案？</h2>
        <p>联系我们的专家团队，获取定制化方案</p>
        <div class="cta-actions">
          <button class="main-btn main-btn-large" @click="goToContact">
            <a><i class="el-icon-phone"></i> 联系专家</a>
          </button>
          <button class="main-btn main-btn-large" @click="goToProducts">
            <a><i class="el-icon-view"></i> 查看产品</a>
          </button>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Headers from '@/components/headers.vue'
import Footer from '@/components/footer.vue'
export default {
  name: 'OfficialSolutions',
  components: {
    Headers,
    Footer
  },
  data() {
    return {
      techItems: [
        {
          title: '教育 AI 实验平台',
          description: '平台为高校及科研机构提供即开即用的AI开发环境，支持多人协作与资源共享，让学生和教师能专注于AI技术的实际应用和创新研究，全面提升教学质量与科研效率',
          //image: require('@/assets/image/bg.jpg') // 替换为你的图片路径
          image: 'https://pic.rmb.bdstatic.com/bjh/cms/240419/b4af40135ffc2e858a838c5564f94762_1713538961.376_904.png@h_1280'
        },
        {
          title: '电商技术支持',
          description: '平台提供一键部署AI模型服务 + 7×24小时专业技术支持 ，帮助电商企业快速搭建并运行AI应用，无需专业运维团队即可实现智能化升级',
          //image: require('@/assets/image/bg.jpg')
          image: 'https://gbres.dfcfw.com/Files/iimage/20250327/555998FBAFC7D4A738418B5B3133E6F2_w3000h2000.jpg'
        },
        {
          title: '智能制造行业',
          description: '借助云算力平台快速部署AI模型，提升生产线的自动化与智能化水平，结合资源按需使用，降低企业IT投入成本',
          //image: require('@/assets/image/bg.jpg')
          image: 'https://img0.baidu.com/it/u=1509312355,1874244676&fm=253&fmt=auto&app=120&f=JPEG?w=1132&h=800'
        },
      ]
    }
  },
  methods: {
    goToContact() {
      // 可以跳转到联系页面或打开联系弹窗
      this.$message.info('请拨打 400-1234-5678 联系我们的专家团队')
    },
    goToProducts() {
      this.$router.push('/official/products')
    }
  }
}
</script>

<style lang="scss" scoped>
.solutions-page {
  min-height: 100vh;
  background: #000;
  color: #ffffff;
}

.page-hero {
  padding: 140px 20px 80px;
  background: radial-gradient(ellipse at center, rgba(102, 126, 234, 0.15) 0%, rgba(10, 14, 26, 1) 70%);
  text-align: center;

  .hero-container {
    max-width: 800px;
    margin: 0 auto;

    h1 {
      font-size: 48px;
      font-weight: 700;
      margin: 0 0 24px;
      background: linear-gradient(135deg, #fff, #fff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      font-size: 20px;
      color: #fff;
      margin: 0;
    }
  }
}

.solution-section {
  padding: 100px 20px;
  background: #000;

  &.alt {
    background: #0d0d12;
  }

  .solution-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .solution-header {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 60px;

    .solution-icon {
      width: 80px;
      height: 80px;
      // background: rgba(128, 128, 128, 0.3);
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 80px;
      }
    }

    h2 {
      font-size: 36px;
      font-weight: 700;
      margin: 0 0 8px;
      color: #ffffff;
    }

    .solution-tagline {
      font-size: 18px;
      color: #fff;
      font-weight: 600;
      margin: 0;
    }
  }

  .solution-content {
    .content-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 60px;
      align-items: start;
    }

    h3 {
      font-size: 28px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    .description {
      font-size: 16px;
      color: #fff;
      line-height: 1.6;
      margin-bottom: 40px;
    }
  }
}

.case-highlights {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;

  .highlight-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 20px;
    text-align: center;

    .highlight-number {
      font-size: 24px;
      font-weight: 700;
      color: #fff;
      margin-bottom: 8px;
    }

    .highlight-label {
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 4px;
    }

    .highlight-desc {
      font-size: 12px;
      color: #fff;
    }
  }
}

.features {
  h4 {
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .feature-list {
    .feature-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      margin-bottom: 16px;

      i {
        color: #fff;
        font-size: 16px;
        margin-top: 2px;
        flex-shrink: 0;
      }

      span {
        color: #fff;
        line-height: 1.4;
      }
    }
  }
}

.case-study {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;

  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .case-stats {
    margin-bottom: 24px;

    .stat-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;

      .stat-label {
        color: #fff;
        font-size: 14px;
      }

      .stat-value {
        color: #fff;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }

  .teaching-tools {
    h5 {
      font-size: 16px;
      color: #ffffff;
      margin: 0 0 16px;
    }

    .tool-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .tool-tag {
        background: rgba(102, 126, 234, 0.2);
        color: #fff;
        padding: 4px 8px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
}

.design-benefits {
  .benefit-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 24px;

    .benefit-icon {
      width: 48px;
      height: 48px;
      // background: linear-gradient(135deg, #fff, #764ba2);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i {
        font-size: 48px;
        color: white;
      }
    }

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin: 0 0 4px;
    }

    p {
      color: #fff;
      margin: 0;
      line-height: 1.4;
    }
  }
}

.workflow-showcase {
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 24px;
  }

  .workflow-steps {
    margin-bottom: 32px;

    .workflow-step {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #fff1;

      .step-number {
        width: 32px;
        height: 32px;
        // background: linear-gradient(135deg, #fff, #764ba2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 600;
        flex-shrink: 0;
      }

      .step-content {
        margin-left: 15px;

        h5 {
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 4px;
        }

        p {
          color: #fff;
          margin: 0;
          font-size: 14px;
        }
      }
    }
  }

  .design-metrics {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    .metric-card {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      padding: 16px;
      text-align: center;

      .metric-number {
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 6px;
      }

      .metric-label {
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 4px;
      }

      .metric-compare {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}

.performance-comparison {
  padding: 100px 0px;
  background: #000;

  .performance-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  h2 {
    font-size: 36px;
    font-weight: 700;
    margin: 0 0 16px;
    background: linear-gradient(135deg, #fff, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .performance-subtitle {
    font-size: 18px;
    color: #fff;
    margin: 0 0 60px;
  }

  .comparison-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 32px;
  }

  .comparison-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 32px;
    text-align: left;

    h3 {
      font-size: 24px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 24px;
      text-align: center;
    }
  }

  .comparison-chart {
    .chart-bar {
      margin-bottom: 16px;

      .bar-label {
        font-size: 14px;
        color: #8892b0;
        margin-bottom: 8px;
      }

      .bar-container {
        position: relative;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        height: 24px;
        overflow: hidden;

        .bar-fill {
          height: 100%;
          border-radius: 8px;
          position: relative;

          &.our-platform {
            background: linear-gradient(135deg, #667eea, #764ba2);
          }

          &.industry-avg,
          &.competitor {
            background: rgba(255, 255, 255, 0.3);
          }
        }

        .bar-value {
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 12px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
  }

  .tech-advantages {
    .advantage-item {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;

      i {
        font-size: 24px;
        color: #667eea;
      }

      h4 {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin: 0 0 4px;
      }

      p {
        color: #8892b0;
        margin: 0;
        font-size: 14px;
      }
    }
  }
}

.cta-section {
  padding: 100px 20px;
  background: linear-gradient(135deg, #000, #000);
  text-align: center;

  .cta-container {
    max-width: 800px;
    margin: 0 auto;

    h2 {
      font-size: 36px;
      font-weight: 700;
      color: white;
      margin: 0 0 16px;
    }

    p {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0 0 40px;
    }

    .cta-actions {
      display: flex;
      justify-content: center;
      gap: 20px;

      .el-button {
        height: 50px;
        padding: 0 32px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 25px;

        &.el-button--primary {
          background: white;
          color: #667eea;
          border: none;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);
          }
        }

        &:not(.el-button--primary) {
          background: transparent;
          border: 2px solid rgba(255, 255, 255, 0.5);
          color: white;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: white;
          }
        }
      }
    }
  }
}

.main-footer {
  background: #0a0e1a;
  padding: 60px 20px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }

  .footer-section {
    h4 {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    p {
      color: #8892b0;
      line-height: 1.6;
      margin: 0 0 8px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 8px;

        a {
          color: #8892b0;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: #667eea;
          }
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      color: #8892b0;
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr !important;
    gap: 40px !important;
  }

  .case-highlights {
    grid-template-columns: 1fr !important;
  }

  .comparison-grid {
    grid-template-columns: 1fr !important;
  }

  .header-nav {
    display: none !important;
  }
}


// 技术特性
.technology-section {
  padding: 100px 20px;
  background: #0f1419;

  .technology-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    margin: 0 0 60px;
    // background: linear-gradient(135deg, #667eea, #764ba2);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }

  .tech-features {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
  }

  .tech-feature {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 32px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      background: rgba(255, 255, 255, 0.08);
    }

    .tech-icon {
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #667eea, #764ba2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px;

      i {
        font-size: 32px;
        color: white;
      }
    }

    h3 {
      font-size: 20px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 12px;
    }

    p {
      color: #8892b0;
      line-height: 1.5;
      margin: 0;
    }
  }
}


.carousel-card {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  color: white;
  border-radius: 16px;
  overflow: hidden;
}

.carousel-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  /* 半透明背景提升文字可读性 */
  border-radius: 12px;

  h3 {
    font-size: 28px;
    margin-bottom: 12px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
  }
}

.el-carousel__item.el-carousel__item--card.is-in-stage.is-active {
  box-shadow: 0 0 30px 0 rgba(0, 100, 100, 0.5);
}

.el-carousel__item {
  border-radius: 16px;
  &:not(.is-active)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
}

.el-carousel {
  overflow: visible;
}
</style>
